"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditFormSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M23.73,7.14A2,2,0,0,0,23,7H4A2,2,0,0,0,2,9V28a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2V9a2,2,0,0,0-.14-.73ZM23,28H4V9H23Z"/><path d="M22.36,5.77,11.69,16.44a.4.4,0,0,0-.1.12l-.05.11a.43.43,0,0,0,0,.16L11,20.22a.69.69,0,0,0,.19.58.68.68,0,0,0,.49.2h.09l3.39-.48a.61.61,0,0,0,.28-.11.31.31,0,0,0,.11-.09L26.23,9.65Z"/><path d="M29.8,5.11,26.89,2.2a.67.67,0,0,0-.48-.2.7.7,0,0,0-.49.2L23.77,4.36l3.88,3.87L29.8,6.08A.68.68,0,0,0,29.8,5.11Z"/>';
var EditFormSVG = function EditFormSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.EditFormSVG = EditFormSVG;
EditFormSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(EditFormSVG);
exports.default = _default;